<template>

    <div class="text-center">

        <div class="row no-gutters align-items-center">

            <slot name="pager-column-before"></slot>

            <div class="text-portal-dark-grey" v-show="totalNumberOfPages > 1" v-bind:class="columnCssToRender">
                <i class="fas fa-chevron-left mr-2 p-2" aria-label="Go to previous page" @click="onIconPageChange(currentPage-1)" v-bind:class="{ 'text-portal-grey disable-while-loading' : isFirstPage || isPaging, 'text-portal-primary-blue c-pointer': !isFirstPage }"></i>
                <span v-once>{{PageText}}</span>
                <span class="d-inline-block text-center pager-text">{{freeTextPageValue}}</span>
                <span class="mr-2 ">{{OfText}} {{totalNumberOfPages}}</span>

                <i class="fas fa-chevron-right text-portal-primary-blue p-2" aria-label="Go to next page" @click="onIconPageChange(currentPage+1)" v-bind:class="{ 'text-portal-grey disable-while-loading' : isLastPage || isPaging, 'text-primary c-pointer': !isLastPage}"></i>

                <!--Sort button on mobile view-->
                <slot name="pager-column-inner-after"></slot>
            </div>

            <slot name="pager-column-after"></slot>
        </div>
    </div>

</template>

<script>

    import './generic.pager.scss';

    export default {
        name: 'pager',
        props: {
            recordsPerPage: { type: Number },
            currentPage: { type: Number },
            fullDataSet: { type: Array },
            pagerColumnCss: { type: Object },
            totalPagesForLabResultsOnPageInit: { type: Number },
            isPaging: { type: Boolean },
            cmsContentBlocks: { type: Object },
            // isPaging is used in Lab Search page in order to prevent from loading duplicate data when a user click page forward/back button quickly.
        },
        data: function () {
            return {
                //holds the timer for the lazy typing
                timer: null,
                freeTextPageValue: this.currentPage
            }
        },
        mounted: function () {
            this.pagerIsVisible();
        },
        computed: {
            PageText: function () {
                if (this.cmsContentBlocks && this.cmsContentBlocks.page) {
                    return this.cmsContentBlocks.page;
                }
                return "Page"
            },

            OfText: function () {
                if (this.cmsContentBlocks && this.cmsContentBlocks.ofText) {
                    return this.cmsContentBlocks.ofText;
                }
                return "of"
            },

            columnCssToRender: function () {
                if (this.pagerColumnCss) {
                    return this.pagerColumnCss;
                }

                return { 'col': true };
            },

            totalNumberOfPages: function () {

                let numberOfPages;

                // In the case of Lab Results, not all data is loaded when page initializes. So we get the total number of pages from the API.
                if (this.totalPagesForLabResultsOnPageInit) {
                    numberOfPages = this.totalPagesForLabResultsOnPageInit;
                } else {
                    numberOfPages = Math.ceil(this.fullDataSet.length / this.recordsPerPage);
                }

                this.$emit('total-number-of-pages-change', numberOfPages);

                return numberOfPages;
            },

            isFirstPage: function () {
                return this.currentPage == 1;
            },

            isLastPage: function () {
                return this.currentPage == this.totalNumberOfPages;
            }

        },
        watch: {

            currentPage: function (newValue, oldValue) {
                this.freeTextPageValue = newValue;
            },

            totalNumberOfPages: function (newValue, oldValue) {
                this.pagerIsVisible();
            }

        },
        methods: {

            pagerIsVisible: function () {
                this.$emit('pagerIsVisible', this.totalNumberOfPages > 1);
            },

            onIconPageChange: function (nextPage) {
                // In the case of Lab Results, not all data is loaded when page initializes. So we grab additional pages of data each time the user clicks forward.
                if (this.totalPagesForLabResultsOnPageInit) {
                    this.$emit("load-more-orders", nextPage);
                }

                this.$emit("change", nextPage, this.$el.id);
            }
        }
    };

</script>



